/*
  NDZ (07/10/2026): banner dei cookie di Noodz (snippets/ndz-cookie.liquid), sulla Customer Privacy API di Shopify.
  - Si mostra quando Shopify dice che nella regione del visitatore serve (shouldShowBanner) e la scelta non c'è ancora
    (currentVisitorConsent vuoto: shouldShowBanner da solo resta vero anche dopo la scelta). Shopify ricorda la scelta.
  - VERSIONE: se cambiano i cookie usati si alza il numero (data-versione nello snippet) e il banner si ripropone a chi
    aveva già scelto (linee guida del Garante: si richiede il consenso quando cambiano le condizioni). Il numero della
    versione scelta sta nel localStorage del browser (serve solo al banner).
  - «Accetta» = statistiche + marketing; «Rifiuta» e la X = solo tecnici; «Preferenze» = scelta per categoria.
  - Statistiche → analytics; marketing → marketing e sale_of_data; preferences resta a no (la lingua e il carrello sono
    cookie tecnici e funzionano comunque).
  - «Preferenze cookie» nel piè di pagina ([data-cookie-apri]) e ogni link a #preferenze-cookie riaprono le scelte.
*/
(function () {
  var radice = document.querySelector('[data-ndz-cookie]');
  if (!radice) return;
  var banner = radice.querySelector('[data-cookie-banner]');
  var pannello = radice.querySelector('[data-cookie-pannello]');
  var esito = radice.querySelector('[data-cookie-esito]');
  var testi = {};
  try { testi = JSON.parse(radice.querySelector('[data-cookie-testi]').textContent); } catch (e) {}
  var api = null;
  var ultimoFocus = null;
  var VERSIONE = radice.dataset.versione || '1';
  function versioneScelta() { try { return localStorage.getItem('ndz_cookie_v'); } catch (e) { return null; } }
  function salvaVersione() { try { localStorage.setItem('ndz_cookie_v', VERSIONE); } catch (e) {} }

  function mostra(el) {
    radice.hidden = false;
    banner.hidden = el !== banner;
    pannello.hidden = el !== pannello;
    var primo = el.querySelector('button:not([data-cookie-chiudi]):not([data-cookie-chiudi-pannello])');
    if (el === pannello && primo) primo.focus();
  }
  function nascondi() {
    banner.hidden = true;
    pannello.hidden = true;
    radice.hidden = true;
    if (ultimoFocus && document.contains(ultimoFocus)) ultimoFocus.focus();
  }
  function interruttori() { return pannello.querySelectorAll('[data-cookie-voce]'); }
  function impostaInterruttori(stato) {
    interruttori().forEach(function (b) { b.setAttribute('aria-checked', String(!!stato[b.dataset.cookieVoce])); });
  }
  function registra(analytics, marketing) {
    if (!api) { nascondi(); return; }
    api.setTrackingConsent(
      { analytics: analytics, marketing: marketing, preferences: false, sale_of_data: marketing },
      function () {
        salvaVersione();
        if (esito) esito.textContent = testi.salvato || '';
        nascondi();
      }
    );
  }
  function apriPreferenze(e) {
    if (e) e.preventDefault();
    ultimoFocus = document.activeElement;
    var c = api ? api.currentVisitorConsent() : {};
    impostaInterruttori({ analytics: c.analytics === 'yes', marketing: c.marketing === 'yes' });
    mostra(pannello);
  }

  radice.querySelectorAll('[data-cookie-accetta]').forEach(function (b) { b.addEventListener('click', function () { registra(true, true); }); });
  radice.querySelectorAll('[data-cookie-rifiuta]').forEach(function (b) { b.addEventListener('click', function () { registra(false, false); }); });
  radice.querySelector('[data-cookie-chiudi]').addEventListener('click', function () { registra(false, false); });
  radice.querySelector('[data-cookie-chiudi-pannello]').addEventListener('click', function () {
    /* chiudere le preferenze senza salvare: se una scelta c'è già resta quella, altrimenti valgono solo i tecnici */
    var c = api ? api.currentVisitorConsent() : {};
    if (!c.analytics && !c.marketing) registra(false, false); else nascondi();
  });
  radice.querySelector('[data-cookie-preferenze]').addEventListener('click', apriPreferenze);
  radice.querySelector('[data-cookie-salva]').addEventListener('click', function () {
    var s = {};
    interruttori().forEach(function (b) { s[b.dataset.cookieVoce] = b.getAttribute('aria-checked') === 'true'; });
    registra(!!s.analytics, !!s.marketing);
  });
  interruttori().forEach(function (b) {
    b.addEventListener('click', function () { b.setAttribute('aria-checked', String(b.getAttribute('aria-checked') !== 'true')); });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cookie-apri], a[href$="#preferenze-cookie"]');
    if (a) apriPreferenze(e);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !pannello.hidden) radice.querySelector('[data-cookie-chiudi-pannello]').click();
  });

  function avvia() {
    api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api) return;
    var c = api.currentVisitorConsent() || {};
    var sceltaFatta = c.analytics === 'yes' || c.analytics === 'no' || c.marketing === 'yes' || c.marketing === 'no';
    if (api.shouldShowBanner() && (!sceltaFatta || versioneScelta() !== VERSIONE)) mostra(banner);
    if (location.hash === '#preferenze-cookie') apriPreferenze();
  }
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (errore) {
      if (!errore) avvia();
    });
  }
})();
